import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';

const LabeledCheckbox = ({disabled, htmlId, name, onChange, label, value}) => {
    return(
        <Checkbox
            divClass="checkbox col-xs-12"
            disabled={disabled}
            htmlId={htmlId}
            name={name}
            onChange={onChange}
            value={value}>
            {label}
        </Checkbox>
    );
};

LabeledCheckbox.propTypes = {
    //Should input be disabled.
    disabled: PropTypes.bool,
    //Html id attribute.
    htmlId: PropTypes.string,
    //Input name.
    name: PropTypes.string,
    //Function triggered when input value changed.
    onChange: PropTypes.func,
    //Checkbox label or nested component
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node 
    ]),
    //Input value
    value: PropTypes.bool,
};

export default LabeledCheckbox;


// WEBPACK FOOTER //
// ./src/components/base/Checkbox/LabeledCheckbox.js